<template>
  <div class="map">
    <div v-show="isOpenSearchPanel" class="w-full z-10 sticky">
      <div v-show="!showSearchPanelFrom && !showSearchPanelTo">
        <span class="bg-yellow-300 text-sm font-bold px-2 py-0.5">
          <span class="material-symbols-outlined">
            moving
          </span>
          <span class="ml-1">目的地へのルートを調べる</span>
        </span>
        <div class="px-2 bg-brand_sub clear-both">
          <div class="float-left pt-2 font-bold mr-2">どこから</div>
          <div class="pt-1 ml-16">
            <div class="w-6 mt-2 ml-4 float-left absolute" @click="onSearchFrom">
              <svg
                class="h-4 w-4 text-supplement"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 56.966 56.966"
                width="512"
                height="512">
                <path d="M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"/>
              </svg>
            </div>
            <div class="w-6 right-3 mt-1 float-right absolute" @click="clearFrom">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"/></svg>
            </div>
            <div class="pl-8 pr-6 py-1 border input_border rounded-lg bg-white truncate" @click="onSearchFrom">{{ from.name !== undefined ? from.name : '現在地' }}</div>
          </div>
          <div class="float-left pt-3 font-bold mr-2">どこまで</div>
          <div class="pt-2 ml-16">
            <div class="w-6 mt-2 ml-4 float-left absolute" @click="onSearchTo">
              <svg
                class="h-4 w-4 text-supplement"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 56.966 56.966"
                width="512"
                height="512">
                <path d="M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"/>
              </svg>
            </div>
            <div class="w-6 right-3 mt-1 float-right absolute" @click="clearTo">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"/></svg>
            </div>
            <div class="pl-8 pr-6 py-1 border input_border rounded-lg bg-white truncate" @click="onSearchTo">{{ to.name !== undefined ? to.name : '現在地' }}</div>
          </div>
          <div class="float-left top-14 pl-4 font-bold absolute" @click="swapPlace">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-link"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/></svg>
          </div>
        </div>
        <div class="w-full bg-brand_sub">
          <div class="float-left pt-3 font-bold ml-6">いつ</div>
          <div class="pt-2 px-2 ml-16">
            <div class="flex" @click="openDatetime">
              <div class="w-full">
                <img src="@/assets/images/icon-schedule.svg" class="w-6 right-3 mt-1 float-right absolute">
                <div class="ml-2 pl-4 pr-8 py-1 border input_border rounded-lg bg-white truncate">{{ getDatetime() }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full pt-1 bg-brand_sub">
          <div class="pt-1 px-2">
            <a class="button-primary block" @click="searchCourse">
              ルートを検索
            </a>
          </div>
        </div>
        <div class="bg-brand_sub text-xs font-bold h-6 px-2 pt-1">
          <div class="float-right">リアルタイム経路検索</div>
          <div class="float-right mt-1 px-1"><img src="@/assets/images/jrLogo.svg" alt="ロゴ" class="w-4" /></div>
          <div class="float-right">Powered by</div>
        </div>
      </div>
    </div>
    <transition tag="form" appear>
      <div v-show="showDatetimeForm" class="bg-brand_sub w-full z-30 absolute top-0" :class="showDatetimeForm ? 'h-full' : 'sticky'">
        <datetime-form
          @setDate="setDate"
          @setTime="setTime"
          @setSearchType="setSearchType"
          @setNow="setNow"
          @closeDatetime="closeDatetime"
          :date="date"
          :time="time"
          :searchType="searchType"
        />
      </div>
    </transition>
    <div v-show="showSearchPanelFrom" class="z-30 h-full w-full pb-4" style="z-index:30;">
      <search-panel
        @setSearch="setSearchFrom"
        @closeSearchPanel="onCloseSearchPanel"
        @clearForm="clearFrom"
        :searchWord="searchWordFrom"
        :isStationOnly="false"
        ref="searchPanelFrom"
      />
    </div>
    <div v-show="showSearchPanelTo" class="z-30 h-full w-full pb-4">
      <search-panel
        @setSearch="setSearchTo"
        @closeSearchPanel="onCloseSearchPanel"
        @clearForm="clearTo"
        :searchWord="searchWordTo"
        :isStationOnly="false"
        ref="searchPanelTo"
      />
    </div>
    <div v-show="showMapPanel" class="w-full pt-22">
      <map-panel
        ref="mapPanel"
        :zoomLevel="zoomLevel"
        :isOpenSearchPanel="isOpenSearchPanel"
        :showSearchWordVia="false"
      />
    </div>
    <div v-show="!showSearchPanelFrom && !showSearchPanelTo && !showDatetimeForm">
      <main-contents />
      <policy />
    </div>
    <div v-show="showPolicyCheck" class="h-full w-full pb-4">
      <policy-check @closePolicyCheck="closePolicyCheck" @acceptPolicyCheck="acceptPolicyCheck"/>
    </div>
    <the-footer class="fixed w-full z-50 h-12" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SearchPanel from '../components/organisms/Map/SearchPanel'
import MapPanel from '../components/organisms/Map/MapPanel'
import DatetimeForm from '../components/organisms/Map/DatetimeForm'
import MainContents from '../components/organisms/Map/MainContents'
import Constants from '../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');
import { event } from 'vue-gtag'
import TheFooter from '../components/organisms/TheFooter.vue'
import Policy from '../components/organisms/Map/Policy'
import PolicyCheck from '../components/organisms/Map/PolicyCheck'

export default {
  created () {
    this.clearFrom()
    this.clearTo()
    if (this.$route.params.latLng) {
      // 指定された緯度経度を中心
      this.$store.dispatch('map/updateCenterLatLng', this.$route.params.latLng)
    } else {
      if (navigator.geolocation) {
        this.$store.dispatch('geolocation/fetchLocation')
          .then(() => {
            const location = this.$store.getters['geolocation/getLocation']
            this.$store.dispatch('map/updateCenter', location)
          })
      }
    }
  },
  components: {
    SearchPanel,
    MapPanel,
    DatetimeForm,
    MainContents,
    TheFooter,
    Policy,
    PolicyCheck
  },
  data () {
    return {
      showMapPanel: false,
      showSearchPanelFrom: false,
      showSearchPanelTo: false,
      searchWordFrom: '',
      searchWordTo: '',
      zoomLevel: 15,
      isOpenSearchPanel: true,
      from: '',
      to: '',
      date: moment(),
      time: moment(),
      searchType: 'now',
      showDatetimeForm: false,
      windowHeight: window.innerHeight,
      showPolicyCheck: false,
    }
  },
  methods: {
    onSearchFrom: function () {
      this.showSearchPanelFrom = true
      this.showSearchPanelTo = false
      this.$refs.searchPanelFrom.setForm(this.from)
    },
    onSearchTo: function () {
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = true
      this.$refs.searchPanelTo.setForm(this.to)
    },
    onCloseSearchPanel: function () {
      this.showSearchPanelFrom = false
      this.showSearchPanelTo = false
    },
    searchCourse: function () {
      if (JSON.stringify(this.from) === JSON.stringify(this.to)) {
        this.$alert({ message: '出発地と目的地が同一です' })
      } else {
        //初回のみポリシーの画面を表示する
        if (!this.rtWebAccept) {
          this.showPolicyCheck = true
        } else {
          if (this.from.location === undefined) {
          event('ルートを検索',{from:"現在地",to:this.to.name,route:"現在地:"+this.to.name})
        } else if (this.to.location === undefined) {
          event('ルートを検索',{from:this.from.name,to:"現在地",route:this.from.name+":現在地"})          
        } else {
          event('ルートを検索',{from:this.from.name,to:this.to.name,route:this.from.name+":"+this.to.name})
        }
        var url = Constants.REAL_TIME_SEARCH_WEB + "?serviceid=niico&utm_source=niigata&utm_medium=referral&utm_campaign=niigata"
        if (this.from.location !== undefined) {
          url += "&frompoi=" + encodeURIComponent(this.from.name)
          if (this.from.stationCode !== undefined) {
            url += "&fromcode=" + this.from.stationCode
          } else {
            url += "&fromlatitude=" + this.from.location.latitude + "&fromlongitude=" + this.from.location.longitude
          }
        }
        if (this.to.location !== undefined) {
          url += "&topoi=" + encodeURIComponent(this.to.name)
          if (this.to.stationCode !== undefined) {
            url += "&tocode=" + this.to.stationCode
          } else {
            url += "&tolatitude=" + this.to.location.latitude + "&tolongitude=" + this.to.location.longitude
          }
        }
        if (this.searchType !== 'now') {
          url += "&searchType=" + this.searchType
          url += "&date=" + this.date.format('YYYYMMDD')
          if (this.searchType === 'departure' || this.searchType === 'arrival') {
            url += "&time=" + this.time.format('HHmm')
          }
        }
        window.open(url, '_blank')          
        }
      }
    },
    closeSearchPanel: function () {
      this.isOpenSearchPanel = false
    },
    setSearchFrom: function (place) {
      this.$store.dispatch('map/setSearchFrom', place)
    },
    setSearchTo: function (place) {
      this.$store.dispatch('map/setSearchTo', place)
    },
    swapPlace: function () {
      const from = this.$store.getters['map/getSearchFrom']
      const to = this.$store.getters['map/getSearchTo']
      this.$store.dispatch('map/setSearchFrom', to)
      this.$store.dispatch('map/setSearchTo', from)
    },
    clearFrom: function () {
      this.$store.dispatch('map/clearSearchFrom')
    },
    clearTo: function () {
      this.$store.dispatch('map/clearSearchTo')
    },
    openDatetime: function () {
      if (this.searchType === 'now') {
        this.date = moment()
        this.time = moment()
        this.searchType = 'departure'
      }
      this.showDatetimeForm = true
    },
    setDate: function (date) {
      this.date = moment(date)
    },
    setTime: function (time) {
      this.time = moment(time, 'HH:mm')
    },
    setSearchType: function (searchType) {
      this.searchType = searchType
    },
    closeDatetime: function () {
      this.showDatetimeForm = false
    },
    setNow: function () {
      this.date = moment()
      this.time = moment()
      this.searchType = 'now'
      this.showDatetimeForm = false
    },
    getDatetime: function () {
      switch (this.searchType) {
        case 'departure':
          return this.date.format('M月D日') + this.time.format(' H時mm分 出発')
        case 'arrival':
          return this.date.format('M月D日') + this.time.format(' H時mm分 到着')
        case 'firstTrain':
          return '始発'
        case 'lastTrain':
          return '終電'
        default:
          return '現在時刻'
      }
    },
    closePolicyCheck: function () {
      this.showPolicyCheck = false
    },
    acceptPolicyCheck: function () {
      this.showPolicyCheck = false
      this.$store.dispatch('user/setRTWebAccept')
      if (this.from.location === undefined) {
          event('ルートを検索',{from:"現在地",to:this.to.name,route:"現在地:"+this.to.name})
        } else if (this.to.location === undefined) {
          event('ルートを検索',{from:this.from.name,to:"現在地",route:this.from.name+":現在地"})          
        } else {
          event('ルートを検索',{from:this.from.name,to:this.to.name,route:this.from.name+":"+this.to.name})
        }
        var url = Constants.REAL_TIME_SEARCH_WEB + "?serviceid=niico&utm_source=niigata&utm_medium=referral&utm_campaign=niigata"
        if (this.from.location !== undefined) {
          url += "&frompoi=" + encodeURIComponent(this.from.name)
          if (this.from.stationCode !== undefined) {
            url += "&fromcode=" + this.from.stationCode
          } else {
            url += "&fromlatitude=" + this.from.location.latitude + "&fromlongitude=" + this.from.location.longitude
          }
        }
        if (this.to.location !== undefined) {
          url += "&topoi=" + encodeURIComponent(this.to.name)
          if (this.to.stationCode !== undefined) {
            url += "&tocode=" + this.to.stationCode
          } else {
            url += "&tolatitude=" + this.to.location.latitude + "&tolongitude=" + this.to.location.longitude
          }
        }
        if (this.searchType !== 'now') {
          url += "&searchType=" + this.searchType
          url += "&date=" + this.date.format('YYYYMMDD')
          if (this.searchType === 'departure' || this.searchType === 'arrival') {
            url += "&time=" + this.time.format('HHmm')
          }
        }
        window.open(url, '_blank')
    },
  },
  computed: {
    ...mapGetters({
      searchFrom: 'map/getSearchFrom',
      searchTo: 'map/getSearchTo',
      rtWebAccept: 'user/getRTWebAccept'
    }),
    height: function () {
      var h = 0
      if (this.isOpenSearchPanel) {
        h = 248
      } else {
        h = 40
      }
      return this.windowHeight - h
    }
  },
  watch: {
    searchFrom: function (val) {
      this.from = val
      this.showSearchPanelFrom = false
      this.isOpenSearchPanel = true
    },
    searchTo: function (val) {
      this.to = val
      this.isOpenSearchPanel = true
      this.showSearchPanelTo = false
    }
  }
}
</script>
